import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "panel"
}
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", {
  for: "consumer",
  class: "form-label"
}, "Consumer", -1)
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  for: "datasource",
  class: "form-label"
}, "Data Source", -1)
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  for: "signaltype",
  class: "form-label"
}, "Signal Type", -1)
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/_createVNode("h5", null, "Envelope", -1)
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = /*#__PURE__*/_createVNode("h5", null, "Body Fields", -1)
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  for: "enabled",
  class: "form-label"
}, "Enabled", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("option", { value: false }, "No", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("option", { value: true }, "Yes", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("button", {
  type: "submit",
  id: "save",
  class: "btn btn-primary"
}, "save", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_block = _resolveComponent("error-block")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", null, _toDisplayString(_ctx.msg), 1),
    _createVNode(_component_error_block, { errors: _ctx.errors }, null, 8, ["errors"]),
    (_ctx.template.Consumer)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("fieldset", null, [
            _createVNode("form", {
              id: 'template_' + _ctx.template.id,
              onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.callSave()), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_3, [
                _hoisted_4,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "consumer",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.template.Consumer = $event)),
                  disabled: ""
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.template.Consumer,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "datasource",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.template.DataSource = $event)),
                  disabled: ""
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.template.DataSource,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  id: "signaltype",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.template.SignalType.id = $event))
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sheqsy_message.items, (value, idx) => {
                    return (_openBlock(), _createBlock("option", {
                      key: idx,
                      value: value.id
                    }, _toDisplayString(value.Message) + _toDisplayString(value.Supported ? '' : ' - unsupported'), 9, ["value"]))
                  }), 128))
                ], 512), [
                  [
                    _vModelSelect,
                    _ctx.template.SignalType.id,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  id: "envelopeDatatype",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.template.Envelope.DataType = $event))
                }, [
                  (_openBlock(), _createBlock(_Fragment, null, _renderList([{ label: 'XML', value: 'xml'}], (item, idx) => {
                    return _createVNode("option", {
                      key: idx,
                      value: item.value
                    }, _toDisplayString(item.label), 9, ["value"])
                  }), 64))
                ], 512), [
                  [
                    _vModelSelect,
                    _ctx.template.Envelope.DataType,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "envelopeWrapper",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.template.Envelope.Wrapper = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.template.Envelope.Wrapper,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.template.Body, (value, field, idx) => {
                  return (_openBlock(), _createBlock("div", {
                    key: idx,
                    class: "input-group mb-3"
                  }, [
                    _createVNode("span", {
                      class: "input-group-text sm-3",
                      id: 'bodyfield-'+idx,
                      style: {"min-width":"8em"}
                    }, _toDisplayString(field), 9, ["id"]),
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      "aria-describedby": 'bodyfield-'+idx,
                      class: "form-control",
                      id: 'body-'+field+'-val',
                      "onUpdate:modelValue": ($event: any) => (_ctx.template.Body[field] = $event)
                    }, null, 8, ["aria-describedby", "id", "onUpdate:modelValue"]), [
                      [
                        _vModelText,
                        _ctx.template.Body[field],
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]))
                }), 128))
              ]),
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  id: "enabled",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.template.Enabled = $event))
                }, [
                  _hoisted_15,
                  _hoisted_16
                ], 512), [
                  [_vModelSelect, _ctx.template.Enabled]
                ])
              ]),
              _hoisted_17,
              _hoisted_18,
              _createVNode("button", {
                class: "btn btn-outline-danger",
                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.callDelete()), ["prevent"]))
              }, "delete")
            ], 40, ["id"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}